import * as React from "react";
function SvgHomeCollection(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 10.208h4V8.622l-5-5-5 5v8.586h7v-5h-1v-2zm1.126 9H6a2 2 0 01-2-2v-6.585l-1.293 1.292-1.414-1.414 9-9a1 1 0 011.414 0l8.707 8.707H22v2h-1v6a4 4 0 01-7.874 1zm4.874-7h-3v3h4v-3h-1z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgHomeCollection);
export default ForwardRef;
